<div style="padding: 10px;" *ngIf="isData">
  <br />
  <mat-form-field>
    <input
      matInput
      (keyup)="applyFilter($event.target.value)"
      placeholder="Filtro"
    />
  </mat-form-field>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>
      <!-- ID Column -->
      <ng-container matColumnDef="NroServicio">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="NroServicio">
          Numero Servicio
        </th>
        <td mat-cell *matCellDef="let row">{{ row.NroServicio }}</td>
      </ng-container>

      <!-- Progress Column -->
      <ng-container matColumnDef="Prioridad">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="Prioridad">
          Prioridad
        </th>
        <td mat-cell *matCellDef="let row">{{ row.Prioridad }}</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="Nombre">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="Nombre">
          Nombre
        </th>
        <td mat-cell *matCellDef="let row">{{ row.Nombre }}</td>
      </ng-container>

      <!-- Color Column -->
      <ng-container matColumnDef="tipoDireccion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="tipoDireccion">
          Tipo Dirección
        </th>
        <td mat-cell *matCellDef="let row">{{ row.tipoDireccion }}</td>
      </ng-container>


      <ng-container matColumnDef="Telefono">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="Telefono">
          Teléfono
        </th>
        <td mat-cell *matCellDef="let row">{{ row.Telefono }}</td>
      </ng-container>

      <ng-container matColumnDef="Direccion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="Direccion">
            Dirección
        </th>
        <td mat-cell *matCellDef="let row">{{ row.Direccion }}</td>
      </ng-container>

      <ng-container matColumnDef="Municipio">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="Municipio">
            Municipio
        </th>
        <td mat-cell *matCellDef="let row">{{ row.Municipio }}</td>
      </ng-container>

      <ng-container matColumnDef="Departamento">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="Departamento">
              Departamento
          </th>
          <td mat-cell *matCellDef="let row">{{ row.Departamento }}</td>
        </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
  </div>
</div>
